import React from 'react';
import styled from 'styled-components';

import Checkmark from './icons/Checkmark';
import Close from './icons/Close';
import { calculateButtonColors } from '../lib/buttonColors';

const OptionPill = ({ label, color, selected, onClick }: {
  label: string,
  color: string,
  selected: boolean,
  onClick?: () => void
}) => {
  const bgColor = selected ? color : 'var(--shine-system-button-text-color)';
  const textColor = !selected ? color : 'var(--shine-system-button-text-color)';

  return <Pill $color={textColor} $bgColor={bgColor} onClick={onClick} $clickable={onClick !== undefined}>
    <span>{label}</span>
    <Circle $leftOffset={selected ? 2 : 2.5} $topOffset={selected ? -3 : -2} $bgColor={textColor}>
      {selected ? <Checkmark size={10} color={bgColor}/> : <Close size={10} color={bgColor}/>}
    </Circle>
  </Pill>;
};

const Pill = styled.span<{ $color: string, $bgColor: string, $clickable: boolean }>`
  font-size: 14px;
  color: ${({ $color }) => $color};
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  background-color: ${({ $bgColor }) => $bgColor};
  ${({ $clickable }) => $clickable ? 'cursor: pointer;' : ''}
`;

const Circle = styled.span<{ $leftOffset: number, $topOffset: number, $bgColor: string }>`
  background-color: ${({ $bgColor }) => $bgColor};
  width: 15px;
  height: 15px;
  border-radius: 10px;
  margin-left: 10px;
  display: inline-block;
  position: relative;

  svg {
    left: ${({ $leftOffset }) => $leftOffset}px;
    top: ${({ $topOffset }) => $topOffset}px;
    position: relative;
  }
`;

export default OptionPill;
